import React from 'react';
import { Terminal } from 'lucide-react';

interface LogoProps {
  isExpanded?: boolean;
  isCentered?: boolean;
  showText?: boolean;
  onClick?: () => void;
}

export function Logo({ 
  isExpanded = true, 
  isCentered = false, 
  showText = true,
  onClick,
}: LogoProps) {
  
  
  return (
    <a 
      onClick={onClick}
      className={`
        flex items-center gap-2.5 group transition-all duration-700 ease-out ${onClick ? 'cursor-pointer' : ''}
        ${isExpanded ? 'justify-start' : isCentered ? 'justify-center w-full' : 'justify-center'}
      `}
    >
  <div className={`logo-icon w-10 h-10 rounded-xl bg-gradient-to-br from-primary-light to-secondary-light dark:from-primary-dark dark:to-secondary-dark flex items-center justify-center transition-transform duration-300 ${onClick ? 'group-hover:scale-110' : ''}`}>
        {/* <Terminal className="w-6 h-6 text-white transform transition-transform duration-300 group-hover:rotate-12" /> */}
        <img src="/mocktrail-logo.png" alt="MockTrail Logo" className="w-8 h-8" />
      </div>
      
      {showText && (
         <h1 
         className={`
           text-2xl font-heading font-bold gradient-text transition-all duration-700 ease-out mt-[6px]
           ${isCentered ? 'opacity-100 scale-100 translate-x-0' : isExpanded ? 'opacity-100 scale-100 translate-x-0' : 'opacity-0 scale-95 -translate-x-4 absolute'}
         `}
       >
         MockTrail
         <span className="relative -top-[12px] ml-1 text-[9px] text-text-secondary-light dark:text-text-secondary-dark">TM</span>
       </h1>
      )}
    </a>
  );
} 